import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStepsCheckmarks = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 156,
	height: 50,
	fill: "none",
	viewBox: "24 20.5 156 50",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#66C870",
			d: "M119.7 30.9a8 8 0 0 1 8-8h33.7a8 8 0 0 1 7 4l9.6 16.3a8 8 0 0 1-.1 8.4l-9.5 14.6a8 8 0 0 1-6.7 3.7h-34a8 8 0 0 1-8-8v-31Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#8EE597",
			d: "M71.2 30.9a8 8 0 0 1 8-8H113a8 8 0 0 1 6.9 4l9.7 16.3a8 8 0 0 1-.2 8.4L120 66.2a8 8 0 0 1-6.7 3.7h-34a8 8 0 0 1-8-8v-31Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#AAFBB2",
			d: "M26.3 30.9a8 8 0 0 1 8-8h33.8a8 8 0 0 1 6.9 4l9.7 16.3a8 8 0 0 1-.2 8.4L75 66.2a8 8 0 0 1-6.7 3.7h-34a8 8 0 0 1-8-8v-31Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#fff",
			strokeLinecap: "round",
			strokeWidth: 3,
			d: "m45.1 48.9 2.4 2.5a3 3 0 0 0 4.4 0l7.7-8.4M94.4 48.9l2.4 2.5a3 3 0 0 0 4.4 0L109 43M139.4 48.9l2.3 2.5a3 3 0 0 0 4.4 0l7.7-8.4"
		})
	]
});
export default SvgStepsCheckmarks;
